import { FieldTypeConstants } from './FieldTypeConstants';

export interface IFieldSize {
    width: number;
    length: number;
    distance: number;
    lineWidth: number;
}

const FieldSizesConstants: { [key in FieldTypeConstants]: IFieldSize} = {
    [FieldTypeConstants.Big]: {
        width: 5000,
        length: 5000,
        distance: 1e4,
        lineWidth: 50,
    },
    [FieldTypeConstants.Medium]: {
        width: 5000,
        length: 4000,
        distance: 8000,
        lineWidth: 50,
    },
    [FieldTypeConstants.Small]: {
        width: 3000,
        length: 3000,
        distance: 6000,
        lineWidth: 50,
    },
};

export { FieldSizesConstants };

